import { berthApiClient } from '../berthApiClient'

import { updateBookingStatusEndpoint } from './endpoint'
import type {
  UpdateBookingStatusParams,
  UpdateBookingStatusRequest,
  UpdateBookingStatusResponse,
} from './type'

export const updateBookingStatus = async (
  params: UpdateBookingStatusParams
): Promise<UpdateBookingStatusResponse> => {
  const body: UpdateBookingStatusRequest = {
    booking_id: params.bookingId,
    status: params.status,
    tenant_id: params.tenantId,
    ...(params.shortenTimeFlag && { shorten_time_flag: params.shortenTimeFlag }),
    ...(params.cancelCalling && { cancel_calling: params.cancelCalling }),
  }
  const res = await berthApiClient.patch<UpdateBookingStatusResponse>(
    updateBookingStatusEndpoint,
    body
  )
  return res.data
}
